export default __webpack_public_path__ + "static/media/loading.7747c0cb.gif";